import React from 'react';

import Lottie from 'lottie-react-web';

import animationData from './animations/index.plk.json';

export const Animation = () => <Lottie style={{ maxWidth: '300px' }} options={{ animationData }} />;
